var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddCircleWhite = function SvgAddCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.023 32.023"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M16.012 4.691A11.318 11.318 0 0 0 4.69 16.012a11.318 11.318 0 0 0 11.32 11.32 11.318 11.318 0 0 0 11.322-11.32 11.318 11.318 0 0 0-11.321-11.32Zm9.994 11.321a9.995 9.995 0 1 1-19.989 0 9.995 9.995 0 0 1 19.989 0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "m22.408 15.346-5.733.003v-5.73a.663.663 0 0 0-1.322.004l-.004 5.726-5.726.003a.663.663 0 0 0 0 1.32l5.726.003.004 5.726a.659.659 0 0 0 .663.664.662.662 0 0 0 .663-.664l-.004-5.726h5.729a.665.665 0 0 0 .003-1.33Z",
    fill: "#fff"
  })))))));
};
export default SvgAddCircleWhite;